import React from "react";
import "./index.css";
import DeviceInfo from "../../components/DeviceInfo";

const SettingsView: React.FC = () => {
  return (
    <div className="">
      <DeviceInfo />
    </div>
  );
};

export default SettingsView;
